// extracted by mini-css-extract-plugin
export default {"brandPromo":"JF-z","carousel":"KF-z"};